import React, { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import useTranslation from '../../../../../../util/hooks/useTranslation';
import cx from 'classnames';
import { TreeSelectContext } from '../../../../../Common/Select/TreeSelect';
import { components } from 'react-select';
import Tree from '../../../../../Common/Select/TreeSelect/Tree';
import { mergeSelected, findAllOptions } from '../../../../../Common/Select/TreeSelect/Parts';
import { CustomTreeSelectContext, CustomTreeSelectDispatchContext } from './index';
import { setEditable } from '../reducer';

export const TreeMenuList = ({ children, getValue, setValue, options, ...restProps }) => {
    const t = useTranslation('TreeSelect');
    const filterT = useTranslation('Filter');
    const selected = getValue();
    const { valueKey, labelKey, treeKey, parentKey, flattenData } = useContext(TreeSelectContext);
    const dispatch = useContext(CustomTreeSelectDispatchContext);
    const { isEditable, disableOption } = useContext(CustomTreeSelectContext);

    const mergedSelection = useMemo(() => {
        return mergeSelected(flattenData, treeKey, parentKey, selected);
    }, [treeKey, parentKey, flattenData, selected]);

    const allOptions = useMemo(() => {
        return findAllOptions(options);
    }, [options]);

    const handleChange = e => {
        const { checked } = e.currentTarget;
        setValue(checked ? allOptions : []);
    };

    // // 초기 체크될 값
    // const [checked, setChecked] = useState(selected ? makeCheckedDescendantsNode(selected.map(v => v[valueKey])) : []);
    const [checked, setChecked] = useState(
        selected.map(v => {
            if (typeof v === 'object') {
                return v[valueKey];
            }
            return v;
        }),
    );

    const handleCheck = useCallback(checked => {
        setChecked(checked);
    }, []);

    useEffect(() => {
        setChecked(
            selected.map(v => {
                if (typeof v === 'object') {
                    return v[valueKey];
                }
                return v;
            }),
        );
    }, [selected.length]);

    useEffect(() => {
        const checkedToStr = checked.map(v => v.toString());
        setValue(flattenData.filter(v => checkedToStr.includes(v[valueKey].toString())).map(v => v[valueKey]));
    }, [checked, flattenData, valueKey]);

    return (
        <components.MenuList {...restProps}>
            <div className={'mb-2'}>
                <div className={'select-group-title'}>{t('Selected')}</div>
                {mergedSelection.length ? (
                    mergedSelection.map((v, index) => {
                        return (
                            <div
                                key={v[valueKey] + index}
                                className={cx('styled-option', isEditable !== 'Y' && 'disabled-select-option')}
                            >
                                <div
                                    onClick={e => {
                                        const filtered = mergedSelection.filter(
                                            selectedOption => selectedOption[valueKey] !== v[valueKey],
                                        );
                                        // setValue(filtered);
                                        setChecked(filtered.map(selectedOption => selectedOption[valueKey]));
                                    }}
                                >
                                    <label className={'text-ellipsis w-100 mb-0'} title={v[labelKey]}>
                                        <input
                                            type="checkbox"
                                            style={{ cursor: 'pointer' }}
                                            value={v[valueKey]}
                                            checked
                                            onChange={e => null}
                                        />
                                        {v[labelKey]}
                                    </label>
                                </div>
                            </div>
                        );
                    })
                ) : (
                    <div className={'styled-option-label'}>{t('Not Selected')}</div>
                )}
            </div>
            <div className={cx('select-group-title pt-0 pb-0', isEditable !== 'Y' && 'disabled-select-option')}>
                <label className={'text-ellipsis mb-0'} title="All Items">
                    <input type="checkbox" onChange={handleChange} checked={selected.length === allOptions.length} />
                    {t('All Items')}
                </label>
            </div>
            {!selected.length && !options.length ? (
                <div className={'styled-option-label'}>{t('No matches found')}</div>
            ) : (
                <div className={cx(isEditable !== 'Y' && 'disabled-tree-option')} style={{ padding: '.5rem' }}>
                    <Tree data={options} checked={checked} setChecked={handleCheck} />
                </div>
            )}
            <div className={cx(disableOption && 'disabled-option')}>
                <div className={'select-group-title'}>{filterT('Option')}</div>
                <div className={'styled-option'}>
                    <label className={'text-ellipsis'} title={filterT('Permission to change')}>
                        <input
                            type="checkbox"
                            checked={isEditable === 'Y'}
                            onChange={e => {
                                dispatch(setEditable(e.currentTarget.checked ? 'Y' : 'N'));
                            }}
                        />
                        {filterT('Permission to change')}
                    </label>
                </div>
            </div>
        </components.MenuList>
    );
};
